import { getColorVariants } from '@/components/GlobalNavigation/DesktopNav/DesktopNav';
import useSharedStyles from '@/components/GlobalNavigation/SharedNav.styles';
import Icon from '@/components/Icon/Icon';
import Link from '@/components/Link/Link';
import CartIcon from '@/components/SunrunShop/CartIcon/CartIcon';
import { Contentful, ContentStyle } from '@/contentful';
import TextLogo from '@/public/cmsAssets/assets/img/logo/TextLogo';

import useStyles from './GlobalMinimalHeader.styles';

export interface GlobalMinimalHeaderContent extends Contentful {
  fields: {
    phoneNumber?: string;
    clickableLogo: boolean;
    variant: 'light' | 'dark';
    style: ContentStyle;
  };
}
export interface GlobalMinimalHeaderProps {
  content: GlobalMinimalHeaderContent;
}

const GlobalMinimalHeader: React.FC<GlobalMinimalHeaderProps> = ({
  content: {
    fields: { phoneNumber, clickableLogo, style },
  },
}: GlobalMinimalHeaderProps) => {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes, cx } = useStyles({ isOnDark });

  const { classes: sharedStyles } = useSharedStyles({ useTransition: true });

  const { logoClass } = getColorVariants(
    isOnDark,
    false,
    false,
    sharedStyles,
    cx
  );

  return (
    <header className={classes.container} data-testid='header'>
      <div className={classes.content} data-testid='content'>
        <div className={classes.logoContainer} data-testid='logoContainer'>
          {clickableLogo ? (
            <Link href='/' data-testid='clickableLogo'>
              <TextLogo classname={cx(logoClass, classes.logo)} width='121' />
            </Link>
          ) : (
            <TextLogo
              classname={cx(logoClass, classes.logo)}
              width='121'
              data-testid='logo'
            />
          )}
        </div>
        <div className={classes.cartAndPhone}>
          {phoneNumber && (
            <div
              className={classes.phoneContainer}
              data-testid='phoneContainer'
            >
              <Icon
                name='Call'
                className={classes.phoneIcon}
                data-testid='phoneIcon'
              />
              <Link
                className={classes.number}
                href={`tel:${phoneNumber}`}
                data-testid='phoneNumber'
              >
                {phoneNumber}
              </Link>
            </div>
          )}

          <CartIcon isOnDark={isOnDark} />
        </div>
      </div>
    </header>
  );
};

export default GlobalMinimalHeader;
